module.exports = __webpack_public_path__ + "static/media/Bulbasaur_gaussian2.bfac830e.png";